import { BuildTheme } from '../../global/Theme-variable'

const ThemeSettings = () => {
  const theme = BuildTheme()
  return theme
}
export default ThemeSettings
